module.exports = __webpack_public_path__ + "static/media/media-square.d63a1253.jpg";